module.exports = __webpack_public_path__ + "static/media/locate-charging-stations-card.c3b208ad.png";